import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* CREATE */
export const createProduct = (data)=>{
  return api.post(ENDPOINTS.PRODUCTS.CREATE,data);
};

/* LIST */
export const listProductByParams = (data)=>{
  return api.post(ENDPOINTS.PRODUCTS.SEARCH,data);
};

/* GET BY ID */
export const getProductById = (id)=>{
  return api.get(ENDPOINTS.PRODUCTS.BY_ID(id));
};

/* UPDATE */
export const updateProduct = (id,data)=>{
  return api.put(ENDPOINTS.PRODUCTS.UPDATE(id),data);
};

/* DELETE */
export const deleteProduct = (id)=>{
  return api.delete(ENDPOINTS.PRODUCTS.DELETE(id));
};

/* FAMILY DROPDOWN */
export const familyDropdown = ()=>{
  return api.get(ENDPOINTS.PRODUCTS.FAMILY_DROPDOWN);
};